import React, { Component } from "react";
import SimpleReactValidator from 'simple-react-validator';
import ocsvalidators, { messages, errorMessageClassName } from '../../utils/ocsvalidators'
import { RequiredTitle } from '../../utils/Util'
import ReactTooltip from 'react-tooltip';
import UserProfile from '../../UserProfile'
import history from '../../../history';
import axios from 'axios'
import authHeader from '../../authentication/authHeader'
import AuthService from '../../authentication/AuthService'

class ClientEdit extends Component {
    constructor(prop) {
        super(prop)
        this.state = {
            oncosmartSystemId: '',
            name: '',
            shortName: '',
            description: '',
            displayOrder: 1,
            activeStatus: 'Y',
            showError: false,
            errorMsg: '',
            clients: [],
            selectedOrganizationId: '',
            organizations: [],
        }
        this.setFocus = React.createRef();
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            className: errorMessageClassName,
            validators: ocsvalidators,
            messages: messages
        });
    }
    componentDidMount() {
        const p = this.props.match.params
        const i = p.id.replace(":", "")

        axios.get('/clients/' + UserProfile.getOrganizationId(), { headers: authHeader() })
            .then(response => {
                axios.get('/organizations', { headers: authHeader() })
                    .then(response1 => {
                        let dataset = [...response1.data]
                        dataset.sort((a, b) => { return a.displayOrder < b.displayOrder ? -1 : a.displayOrder > b.displayOrder ? 1 : 0 })
                        const tt = response.data.filter((e) => e.codesetItemId === parseInt(i))
                        if (tt.length > 0) {
                            this.setState({
                                oncosmartSystemId: tt[0].oncosmartSystemId,
                                codesetItemId: tt[0].codesetItemId,
                                name: tt[0].name,
                                shortName: tt[0].shortName,
                                description: tt[0].description,
                                displayOrder: tt[0].displayOrder,
                                activeStatus: tt[0].activeStatus,
                                createdBy: tt[0].createdBy,
                                clients: response.data,
                                organizations: dataset,
                                selectedOrganizationId: UserProfile.getOrganizationId(),
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        history.push('/Errorpage')
                    })
            })
            .catch(function (error) {
                console.log(error);
                history.push('/Errorpage')
            })
        this.setFocus.current.focus();
    }
    saveClickHandler = () => {
        if (!this.validator.allValid()) {
            this.validator.showMessages();
            return;
        }
        const t = this.state.clients.filter(e => e.name === this.state.name && e.codesetItemId !== this.state.codesetItemId)
        if (t.length > 0) {
            this.setState({
                showError: true,
                errorMsg: `'${this.state.name}' name already exists`
            });
            return;
        }

        axios.put('/client', {
            codesetId: 8,
            codesetItemId: this.state.codesetItemId,
            parentId: this.state.selectedOrganizationId,
            name: this.state.name,
            shortName: this.state.shortName,
            description: this.state.description,
            displayOrder: this.state.displayOrder,
            activeStatus: this.state.activeStatus,
            deletedYN: 'N',
            createdBy: AuthService.getCurrentUserName(),
            lastUpdatedBy: AuthService.getCurrentUserName()
        }, { headers: authHeader() })
            .then(response => {
                axios.get('/clients', { headers: authHeader() })
                    .then(resp => {
                        let clients = []
                        const aclients = resp.data.filter(e => e.activeStatus === 'Y')
                        aclients.forEach(e => {
                            clients.push({ id: e.codesetItemId, name: e.name, displayOrder: e.displayOrder, parentId: e.parentId })
                        })
                        clients.sort((a, b) => { return a.displayOrder < b.displayOrder ? -1 : a.displayOrder > b.displayOrder ? 1 : 0 })
                        let t = UserProfile.getGlobalClientParams()
                        t.clients = clients
                        localStorage.setItem("client", JSON.stringify(t));
                        UserProfile.setPage("Client");
                        UserProfile.setOrganizationId(this.state.selectedOrganizationId)
                        UserProfile.setClientId(response.data.codesetItemId)
                        UserProfile.setHighlights([response.data.codesetItemId], 'success')
                        history.push('/standardcode');
                    })
                    .catch(function (error) {
                        console.log(error);
                        history.push('/Errorpage')
                    })
            })
            .catch(function (error) {
                console.log(error);
                history.push('/Errorpage')
            })
    }
    cancelClickHandler = () => {
        UserProfile.setPage("Client");
        UserProfile.setHighlights([this.state.codesetItemId], 'info')
        history.push('/standardcode');
    }
    render() {
        return (
            <div className="container-fluid">
                <div className="section-title">
                    <h4>Edit Client</h4>
                </div>
                <RequiredTitle />
                <div style={{ display: (this.state.showError ? 'block' : 'none') }}>
                    <label htmlFor="error" style={{ color: 'red' }}>{this.state.errorMsg}</label>
                </div>
                <div className="section-title containerAdd">
                    <table className="table table-striped table-bordered">
                        <thead className="thead-dark">
                        </thead>
                        <tbody>
                            <tr>
                                <td className="col-auto">Organization<span className='text-danger ml-1'>*</span></td>
                                <td className="col-auto">
                                    <select className="form-control" value={this.state.selectedOrganizationId}
                                        name="selectedOrganizationId" onChange={(e) => this.setState({ [e.target.name]: e.target.value })}
                                        ref={this.setFocus}>
                                        <option value="0">--  Select Organization  --</option>
                                        {this.state.organizations.length > 0
                                            && this.state.organizations.map((o, i) => {
                                                return (
                                                    <option key={i} value={o.codesetItemId}>{o.name}</option>
                                                )
                                            })}
                                    </select>
                                    {this.validator.message('selectedOrganizationId', this.state.selectedOrganizationId, 'required|not_in:0')}
                                </td>
                            </tr>
                            <tr>
                                <td className="col-auto">Name<span className='text-danger ml-1'>*</span></td>
                                <td className="col-auto"><input type="text"
                                    name="name"
                                    value={this.state.name}
                                    onChange={(e) => this.setState({ [e.target.name]: e.target.value, showError: false })}
                                    className="form-control" placeholder="Name" />
                                    {this.validator.message('Name', this.state.name, 'required')}
                                </td>
                            </tr>
                            <tr>
                                <td className="col-auto">Short Name<span className='text-danger ml-1'>*</span></td>
                                <td className="col-auto"><input type="text"
                                    name="shortName"
                                    value={this.state.shortName}
                                    maxLength={10}
                                    onChange={(e) => this.setState({ [e.target.name]: e.target.value, showError: false })}
                                    className="form-control" placeholder="Short Name" />
                                    {this.validator.message('Short Name', this.state.shortName, 'required')}
                                </td>
                            </tr>
                            <tr>
                                <td>Description<span className='text-danger ml-1'>*</span></td>
                                <td className="col-auto"><textarea className="form-control"
                                    name="description"
                                    value={this.state.description}
                                    onChange={(e) => this.setState({ [e.target.name]: e.target.value })}
                                    rows="3" placeholder="Description"></textarea>Maximum 200 characters
                                    {this.validator.message('Description', this.state.description, 'required|maxLength:200')}
                                </td>
                            </tr>
                            <tr>
                                <td>Display Order<span className='text-danger ml-1'>*</span></td>
                                <td><input type="text"
                                    name="displayOrder"
                                    value={this.state.displayOrder}
                                    onChange={(e) => this.setState({ [e.target.name]: e.target.value })}
                                    className="col-lg-2 form-control" pattern="[0-9]*" maxLength="3" />
                                    {this.validator.message('Display Order', this.state.displayOrder, 'required|numeric|min:0,num|numeric|max:99999,num')}
                                </td>
                            </tr>
                            <tr>
                                <td>Active?<span className='text-danger ml-1'>*</span></td>
                                <td className="form-inline">
                                    <div className="form-group mx-sm-1 mb-1">
                                        <input className="form-check-input" type="radio" name="activeStatus" id="yes" value="Y" checked={this.state.activeStatus === "Y"} onChange={(e) => this.setState({ [e.target.name]: e.target.value })} />
                                        <label className="form-check-label" htmlFor="yes">Yes</label>
                                    </div>

                                    <div className="form-group mx-sm-4 mb-1 mx-lg-3">
                                        <input className="form-check-input" type="radio" name="activeStatus" id="no" value="N" checked={this.state.activeStatus === "N"} onChange={(e) => this.setState({ [e.target.name]: e.target.value })} />
                                        <label className="form-check-label" htmlFor="no">No</label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2">
                                    <ReactTooltip />
                                    <button type="button" onClick={this.saveClickHandler} className="btn btn-primary" data-tip="Save">Save</button>&nbsp;
                                    <button type="button" onClick={this.cancelClickHandler} className="btn btn-secondary" data-tip="Cancel">Cancel</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

export default ClientEdit